<template>
     
     <div class=" z-10 bg-gray-50  w-full left-0  sticky top-0 ">
    <div class="absolute inset-0 shadow z-30 pointer-events-none" aria-hidden="true"></div>
    <div class="relative z-20 bg-black-50  ">
      <div class="max-w-full mx-auto flex justify-between items-center px-4 py-5 sm:px-6 sm:py-2 lg:px-0 md:justify-start md:space-x-10">

         <!--title starts-->
             <div class="flex justify-between px-4 h-full py-2 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8 w-full">
                  <p class="cb-text-h3 flex items-center gap-4 ">
                    <span v-if="titleIcon">
                        <slot name="iconTitle"></slot>
                    </span>
                    {{title}}</p>
                  <div class="mt-4 flex sm:mt-0 gap-x-2">
                    <slot></slot>
                
                  </div>



                 </div>
         <!--title ends-->

      

      </div>
    </div>
  
   
  
  </div>
  
  <div class="h-6"></div>
        <!-- header -->
</template>

<script>
export default {
    props: {
        title: {
            type: String
        },
        titleIcon: {
            type: Boolean
        }
    }
    
}
</script>